import React from 'react';
import { siteConfig } from '../config/site';
export function SiteHeader() {
  return <header className="no-print w-full bg-teal" data-id="element-64" data-mp="19vrjd4334wog">
      <div className="mx-auto max-w-5xl px-6 py-4 text-center" data-id="element-65" data-mp="19uzyoob10jcy">
        <a href={siteConfig.mainSiteUrl} className="font-display text-[11px] uppercase tracking-[0.16em] text-cream/85 transition-colors duration-150 ease-out hover:text-cream-light sm:text-[13px]" data-id="element-66" data-mp="1nn671o7xtm1u">
          {siteConfig.brand.practitioner} · {siteConfig.brand.practice}
        </a>
      </div>
    </header>;
}